<template>
  <div v-if="isLoading" class="grid place-items-center">
    <CircleSpinner />
  </div>

  <div v-else>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { CircleSpinner } from '@ramp106/omrjs-core-ui'

interface FetcherProps {
  isLoading?: boolean
}

defineProps<FetcherProps>()
</script>
